import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { applicationTypeToGetThisJobButtonText } from 'src/app/models/job-application';
import { Blueshift as CmaBlueshift} from '../multi-select/multi-select.component';
import { ApiV1Job, Blueshift } from '@bluecrew/crew-member-backend-angular-client';

@Component({
  selector: 'app-schedule-confirmation',
  templateUrl: './schedule-confirmation.component.html',
  styleUrls: ['./schedule-confirmation.component.scss'],
})
export class ScheduleConfirmationComponent implements OnInit {

  @Input() schedule?: ApiV1Job;
  @Input() blueshifts?: CmaBlueshift[];
  @Input() directInvitesToBeRejected?: CmaBlueshift[] = [];
  @Input() modalId: string;
  @Output() confirmEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private readonly modalCtrl: ModalController) { }

  ngOnInit() {}

  // Converts Multi-Select Blueshift to CMOS Blueshift used by BlueshiftListComponent
  getBlueshifts(blueshifts: CmaBlueshift[]): Blueshift[] {
    return blueshifts.map(cmaBlueshift => {
      return {
        jobId: cmaBlueshift.externalJobId,
        isDirectInvite: !!cmaBlueshift.isDirectInvite,
        startDateTime: cmaBlueshift.startDateTime,
        endDateTime: cmaBlueshift.endDateTime,
        wage: cmaBlueshift.wage
      };
    });
  }

  async closeModal() {
    // dismiss this modal by id since it's presented on another modal
    await this.modalCtrl.dismiss({}, undefined, this.modalId);
  }

  async getJob() {
    this.confirmEvent.emit();
    // dismiss this modal by id since it's presented on another modal
    await this.modalCtrl.dismiss({}, undefined, this.modalId);
  }

  getHeaderText() {
    return this.blueshifts && this.blueshifts.length > 0 ? 'Are these the shifts you’d like?' : 'Is this the schedule you’d like?';
  }

  getJobButtonText() {
    return this.blueshifts && this.blueshifts.length > 0 ?
      'Yes, looks good' :
      `Yes, ${(applicationTypeToGetThisJobButtonText[this.schedule?.type] || 'get this job').toLowerCase()}`;
  }
}
